import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  stopLoading,
  hasError,
  conversationsAdapterSelectors,
} from 'src/redux/slices/chat';
import { getConversations } from 'src/redux/thunks/conversation';

const useUserConversations = () => {
  const conversations = useSelector((state) =>
    conversationsAdapterSelectors.selectEntities(state.chat.conversations)
  );
  const user = useSelector((state) => state.user);
  const { isLoading, error } = useSelector((state) => state.chat);
  const dispatch = useDispatch();

  useEffect(() => {
    loadConversations(dispatch, user.id, user.currentWorkspace);
  }, [dispatch]);

  return {
    conversations,
    user,
    conversationsLoading: isLoading,
    conversationsError: error,
  };
};

const loadConversations = async (dispatch, userId, workspaceId) => {
  try {
    await dispatch(
      getConversations({
        userId,
        workspaceId,
      })
    ).unwrap();
    dispatch(stopLoading());
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default useUserConversations;
